import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-advanced-settings-password',
  templateUrl: './advanced-settings-password.component.html',
  styleUrls: [
    './advanced-settings-password.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsPasswordComponent implements OnInit {

  passcode: string = "";
  passcodeConfirm: string = "";
  otp: string = "";
  delaySendOTP: number = 0;
  userInfo: any;

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private auth: AuthServiceService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(selectUser)).subscribe((response: any) => {
      try {
        if (response) {
          const data = response;

          this.userInfo = {
            isVerified: data.isVerified,
            phone: data.phone,
          };

          this.cdr.detectChanges();
          this.appRef.tick();
        }
      } catch (error) {
        console.log("error", error, "PROFILE")
      }
    });
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}));
  }

  handleSendOTP() {
    if (this.delaySendOTP < 1)
      this.auth
        .member_send_otp({
          phone: this.userInfo?.phone,
        })
        .subscribe(
          (resp: any) => {
            const result = resp.body;
            if (result.success) {
              this.toastr.success(resp.message);
            } else {
              this.toastr.error(resp.message);
            }
            this.delaySendOTP = 61;
            let interval = setInterval(() => {
              this.delaySendOTP -= 1;
              if (this.delaySendOTP == 0) {
                clearInterval(interval);
              }
              this.cdr.detectChanges();
              this.appRef.tick();
            }, 1000);
          },
          () => {
            this.toastr.error('Internal Server Error');
          }
        );
  }

  handleVerify() {
    if (this.passcode == '') return this.toastr.error('Please Fill Passcode');
    if (this.passcode != this.passcodeConfirm) {
      return this.toastr.error("Passcode Confirmation Doesn't Match");
    }

    if (this.otp == '') return this.toastr.error('Please Fill OTP');

    this.auth
      .member_reset_passcode({
        password: this.passcode,
        otp: this.otp,
        phone: this.userInfo?.phone,
      })
      .subscribe(
        (resp: any) => {
          const result = resp.body;
          if (result.success) {
            this.toastr.success(resp.message);
            this.passcode = '';
            this.passcodeConfirm = '';
            this.otp = '';
            this.delaySendOTP = 0;
            this.cdr.detectChanges();
            this.appRef.tick();
          } else {
            this.toastr.error(resp.message);
          }
        },
        () => {
          this.toastr.error('Internal Server Error');
        }
      );
  }

  async onChangeOtp(e: any) {
    this.otp = e.target.value;
  }

  async onChangePasscode(e: any) {
    this.passcode = e.target.value;
  }
}
